export type UserCalendar = {
  calendarWebsiteUrl: string;
  calendlyCalendarUrl: string;
  googleCalendarId: string;
  platform: number;
};

export enum CALENDAR_VIEW {
  LANDING,
  SCHEDULING,
  SCHEDULED,
}

export enum CALENDAR_PLATFORM {
  GOOGLE = 1,
  CALENLDY = 2,
  OUTLOOK = 3,
  WEBSITE = 4,
}
